export interface FolderNameValidationResult {
    valid: boolean;
    normalized: string;
    errors: {
        empty?: boolean;
        tooLong?: boolean;
        invalidChars?: boolean;
        duplicate?: boolean;
    };
}

const MAX_LENGTH = 60;
const ALLOWED_REGEX = /^[A-Za-z0-9 _.-]+$/;

export function normalizeFolderName(name: string): string {
    return name.trim().replace(/\s+/g, ' ');
}

export function validateFolderName(name: string, existingNames: string[]): FolderNameValidationResult {
    const normalized = normalizeFolderName(name);
    const errors: FolderNameValidationResult['errors'] = {};

    if (!normalized) {
        errors.empty = true;
    }
    if (normalized.length > MAX_LENGTH) {
        errors.tooLong = true;
    }
    if (normalized && !ALLOWED_REGEX.test(normalized)) {
        errors.invalidChars = true;
    }
    const lower = normalized.toLowerCase();
    if (existingNames.map(n => n.toLowerCase()).includes(lower)) {
        errors.duplicate = true;
    }

    return {
        valid: Object.keys(errors).length === 0,
        normalized,
        errors
    };
}

export function folderValidationMessage(result: FolderNameValidationResult): string | null {
    if (result.valid) return null;
    if (result.errors.empty) return 'Folder name is required';
    if (result.errors.tooLong) return `Folder name must be ≤ ${MAX_LENGTH} characters`;
    if (result.errors.invalidChars) return 'Only letters, numbers, spaces, period, underscore and hyphen allowed';
    if (result.errors.duplicate) return 'A folder with this name already exists';
    return 'Invalid folder name';
}
